// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initCrashReporting } from './utils/crashReporter';
import { initWebVitals } from './utils/webVitals';
import App from './App';

// Start global error tracking (logs to Firestore crashReports collection)
initCrashReporting();

// Start Core Web Vitals collection (LCP, INP, CLS, FCP, TTFB)
initWebVitals();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => console.log('[SW] Registered:', reg.scope))
      .catch((err) => console.warn('[SW] Registration failed:', err));
  });
}
